<template>
  <div class="view">
    <container>
      <header-group
        heading="Evaluering"
        subheading="Her kan du se hvordan det går med dine deltagere">
      </header-group>
      <h2>Udsend evalueringsskemaer</h2>
      <p>{{instructions}}</p>
      <p v-if="sending">Sender. Luk ikke for vinduet</p>
      <div class="send-survey">
        <button @click="sendSurvey('pre')" v-if="allowPreEvaluation">Før</button>
        <button @click="sendSurvey('post')" v-if="allowPostEvaluation">Efter</button>
        <button @click="sendSurvey('sharp_brains')" v-if="allowSharpBrainsEvaluation">Efter</button>
        <!-- <button @click="sendSurvey('sharp_brains')">Skarpe hjerner og mentalt overskud</button> -->
      </div>
      <!-- <graph :pre="preAnswers" :post="postAnswers" key-x="question" key-y="answer" :height="400"></graph> -->
      <!-- -->
      <h2>Se resultater for</h2>
      <p
        v-for="attendee in attendees"
        class="attendee"
        :class="setClasses(attendee.id)"
        @click="setIndex(attendee.id)">
          {{attendee.name}}
      </p>
      <p
        class="attendee has-survey"
        :class="{'chosen' : this.average}"
        @click="setIndex('AVERAGE')">
          Gennemsnit
      </p>

      <div v-if="preComment">
        <strong>Kommentar før:</strong>
        <p>{{preComment}}</p>
      </div>

      <div v-if="postComment">
        <strong>Kommentar efter:</strong>
        <p>{{postComment}}</p>
      </div>

      <vertical-graph :pre="preAnswers" :post="postAnswers" v-if="preAnswers || postAnswers"></vertical-graph>

    </container>
  </div>
</template>

<script>
import view from '../mixins/view'
import HeaderGroup from 'components/HeaderGroup'
import Graph from 'components/Graph'
import VerticalGraph from 'components/VerticalGraph'
import Bar from 'components/Bar'
import api from 'api'
import { http } from 'api/resources'

export default {
  name: 'Survey',
  mixins: [view],
  components: {
    HeaderGroup, Graph, Bar, VerticalGraph
  },
  data () {
    return {
      selectedIndex: 0,
      average: true,
      sending: false,
      instructions: 'Her kan du udsende før og efter evalueringer til dine deltagere. Når du trykker på “før” eller “efter” udsendes evalueringen til alle deltagende på holdet. Vær opmærksom på at hver gang du trykker sendes til alle som ikke har besvaret evalueringen. Sørg derfor for at samle dine udsendelser så du undgår at spamme dine deltagere. Ønsker en deltager ikke at udfylde evaluering kan du slette denne i menuen “deltagere”.'
    }
  },
  computed: {
    id () {
      return parseInt(this.$route.params.team)
    },
    isSharpBrains() {
      return this.team !== null && this.team.evaluations.includes('sharp_brains')
    },
    preAnswers () {
      if (this.isSharpBrains) {
        return []
      } else {
        let answers = this.average ? this.getSurveyAverage('pre') : this.getSurvey('pre', 'answers')
        return answers || []
      }
    },
    postAnswers () {
      let key = this.isSharpBrains ? 'sharp_brains' : 'post'
      let answers = this.average ? this.getSurveyAverage(key) : this.getSurvey(key, 'answers')
      return answers || []
    },
    preComment () {
      return this.getSurvey('pre', 'comment')
    },
    postComment () {
      return this.getSurvey('post', 'comment')
    },
    activeAttendee () {
      return this.attendees && this.attendees.find(attendee => attendee.id === this.selectedIndex)
    },
    activeAttendeeName () {
      return this.activeAttendee && this.activeAttendee.name
    },
    surveysNotDefined () {
      return (!this.surveys || !this.surveys.pre.attendees || !this.surveys.post.attendees)
    },
    attendees () {
      return this.team && this.team.attendees
    },
    allowPreEvaluation() {
      return this.team && this.team.evaluations.includes('pre')
    },
    allowPostEvaluation() {
      return this.team && this.team.evaluations.includes('post')
    },
    allowSharpBrainsEvaluation() {
      return this.team && this.isSharpBrains
    }
  },
  methods: {
    setIndex (index) {
      if (index === 'AVERAGE') {
        /**
         * Show average
         */
        this.average = true
        this.selectedIndex = 0
        return
      } else {
        this.average = false
      }
      this.selectedIndex = index
    },
    isActive (index) {
      return index === this.selectedIndex
    },
    setClasses (index) {
      return {
        'has-survey': this.hasSurvey(index),
        'chosen': this.isActive(index) && !this.average
      }
    },
    hasSurvey (attendeeIndex) {
      if (!this.surveys) return

      let searchSurveyType = this.isSharpBrains ? 'sharp_brains' : 'pre'
      return this.surveys[searchSurveyType].attendees.find(survey => survey.attendee.id === attendeeIndex)
    },
    getSurvey (key, key2) {
      if (this.surveysNotDefined) return

      const survey = this.surveys[key].attendees.find(survey => survey.attendee.id === this.selectedIndex)
      if (survey) return survey[key2]
    },
    getSurveyAverage (key) {
      if (this.surveysNotDefined) return
      return this.surveys[key].average
    },
    sendSurvey (type) {
      this.sending = true
      http.post(`me/teams/${this.id}/survey/${type}`).then(response => {
        this.sending = false
        console.log(response)
      })
    },
    hasAnswer (type, index) {
      return this[`${type}Answers`] && this[`${type}Answers`][index]
    }
  },
  asyncComputed: {
    surveys () {
      return api.getSurvey(this.id)
    },
    team () {
      return api.getTeams()
      .then(response => response.data)
      .then(teams => teams.find(team => team.id === this.id))
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/boilerplate';

h3 {
  opacity: 0.25;

  &.active {
    opacity: 1;
  }
}
.attendee {
  opacity: .25;
  pointer-events: none;

  &.has-survey {
    opacity: 1;
    cursor: pointer;
    pointer-events: all;
  }
  &.chosen {
    font-weight: bold;
    cursor: default;
  }
}
.graph {
  margin-top: 4rem;
}
.send-survey {
  margin-bottom: 4rem;
}
.legend {
  &.horisontal {
    // display: flex;

    p {
      margin-right: 2rem;
    }
  }
  p {
    display: flex;
    align-items: center;
    margin-top: 0.5rem;
  }
  .circle {
    display: block;
    width: 1rem;
    height: 1rem;
    background: currentcolor;
    margin-right: .75rem;
    border-radius: 50%;
    color: #ccc;

    &.post {
      color: $color-orange;
    }
  }
}
.question {
  margin-top: 2rem;
}
.entry {
  display: flex;
  align-items: center;

  p {
    width: 7rem;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Survey.vue?a4260d0c